export default __webpack_public_path__ + "graphics/cover.244ddd82.jpg";